/** @jsxRuntime classic */
/** @jsx jsx */
import { css, jsx } from "@emotion/react";
import { useI18n } from "hooks/i18n/i18n";

import type { FcWithoutChildren } from "types/fcWithoutChildren";

type Props = {
  count: number;
};

export const SearchResultListCount: FcWithoutChildren<Props> = (props) => {
  const { count } = props;
  const { t } = useI18n();

  return (
    <p aria-live="polite" css={rootStyle} role="status">
      {count}
      {t("search.resultCountUnit")}
    </p>
  );
};

const rootStyle = css`
  font-size: 18px;
  font-weight: 700;
  line-height: 1.5;
`;
